import { Flex } from '@chakra-ui/react';
import Image from 'next/image';
import { makeDocsLink } from '../utils';

// The maximum width that image could ever render in the docs container
const MAX_WIDTH = 1000;

export function DocsImage({
  src,
  alt,
  width,
  height
}: {
  src: string;
  alt: string;
  width: number;
  height: number;
}) {
  const widthScaleRatio = width > MAX_WIDTH ? MAX_WIDTH / width : 1;

  return (
    <Flex mx="auto" justifyContent="center" my={8}>
      <Image
        src={makeDocsLink(src)}
        alt={alt}
        width={Math.floor(width * widthScaleRatio)}
        height={Math.floor(height * widthScaleRatio)}
      />
    </Flex>
  );
}
